import { useQuery, useQueryClient } from '@tanstack/react-query';

/* keys */
import { homeHubQueryKeys } from './queries.keys';

/*
 * This returns the "cache" for homeHub
 * No api happens here, just a helper to read cache
 *
 * Note: getQueryData is not a promise based item, I use it with useQuery because I
 * wanted to have the option of having those helper vars (status, data) etc..
 * and use it with the "select".
 * */

const useHomeHubCache = <T extends unknown = any>(select?: (data: any) => T): T => {
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: homeHubQueryKeys.all,

    queryFn: () => {
      const homeHub = queryClient.getQueryData(homeHubQueryKeys.all);
      return homeHub;
    },
    select,
    initialData: {},
  });

  return data as T;
};

export default useHomeHubCache;
